import React from 'react';
import PropTypes from 'prop-types';
import useScrollOnRender from '../../Hooks/useScrollOnRender.js';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export const WorkbookNavItem = ({
  subtitle,
  title,
  current,
  shouldScrollTo,
  onClick,
  completed,
  showCompleted = true,
  buttonLike = false,
  variant = 'default',
  statusElement = null,
  trailingElement = null,
  isLoading = false
}) => {
  let scrollRef = useScrollOnRender(shouldScrollTo, false, -10);
  const variantClasses = {
    default: '',
    chapter: 'px-4 py-3 text-slate-800',
    lesson: `border-b border-slate-100 px-4 py-3 text-slate-600 ${current ? 'border-l-2 border-l-pdteal bg-slate-50 text-slate-900' : ''}`
  };
  const currentClasses = buttonLike
    ? 'data-[current=true]:sticky data-[current=true]:-top-0.5 data-[current=true]:z-10 data-[current=true]:text-gray-900'
    : current
      ? 'text-gray-900'
      : '';

  return (
    <>
      <div className="flex w-full items-center">
        <div
          onClick={onClick}
          ref={scrollRef}
          className={`border-pdlightgray relative flex w-full cursor-pointer items-center gap-3 bg-white px-4 py-5 text-neutral-500 transition-[background-color,opacity,transform] duration-200 data-[buttonlike=true]:rounded-[18px] data-[buttonlike=true]:px-3 data-[buttonlike=true]:py-2 data-[showcompleted=true]:border-b data-[loading=true]:bg-pdteal/5 ${currentClasses} ${variantClasses[variant] ?? ''}`}
          data-current={current}
          data-showcompleted={showCompleted}
          data-buttonlike={buttonLike}
          data-variant={variant}
          data-loading={isLoading}
        >
          <div className="min-w-0 flex-1 transition-opacity duration-200 data-[loading=true]:opacity-75" data-loading={isLoading}>
            <span className="text-sm leading-tight font-semibold tracking-wide text-gray-500 uppercase data-[buttonlike=true]:text-[11px] data-[buttonlike=true]:leading-none data-[variant=chapter]:text-[10px] data-[variant=chapter]:font-bold data-[variant=chapter]:tracking-[0.16em] data-[variant=chapter]:text-slate-500 data-[variant=lesson]:text-[10px] data-[variant=lesson]:font-bold data-[variant=lesson]:tracking-[0.14em] data-[variant=lesson]:text-slate-400 lg:font-bold">
              {title?.toUpperCase()}
            </span>
            <span className="block w-full text-2xl leading-loose font-extrabold data-[buttonlike=true]:mt-1 data-[buttonlike=true]:text-[2rem] data-[buttonlike=true]:leading-tight data-[variant=chapter]:mt-0.5 data-[variant=chapter]:text-lg data-[variant=chapter]:leading-snug data-[variant=chapter]:font-bold data-[variant=lesson]:mt-0.5 data-[variant=lesson]:text-base data-[variant=lesson]:leading-snug data-[variant=lesson]:font-medium lg:font-black">
              {subtitle}
            </span>
          </div>
          {statusElement}
          {trailingElement}
          {showCompleted && (
            <CheckCircleIcon
              className="size-7 shrink-0 text-transparent data-[completed=true]:text-pdteal data-[variant=chapter]:size-6 data-[variant=lesson]:size-6"
              data-completed={completed}
              data-variant={variant}
            />
          )}
        </div>
      </div>
    </>
  );
};

WorkbookNavItem.propTypes = {
  subtitle: PropTypes.string,
  title: PropTypes.string,
  current: PropTypes.bool,
  shouldScrollTo: PropTypes.bool,
  onClick: PropTypes.func,
  completed: PropTypes.bool,
  buttonLike: PropTypes.bool,
  variant: PropTypes.string,
  statusElement: PropTypes.node,
  trailingElement: PropTypes.node,
  isLoading: PropTypes.bool
};
